import { DateHelpers } from '@shared/helpers';

export const toRequestDate = (date: string) =>
    date ? DateHelpers.dateFormatter({ date, format: 'YYYY-MM-DD' }) : '';
